import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_PARTNER_GET_BY_USER_ID,
} from 'api/actionTypes';

export default async function loadCurrentPartner({ state, apiClient }, { userId, forceRefresh = false }) {
  typeCheck('userId::PositiveNumber', userId);
  const currentPartnerStatePath = ['partners', 'currentPartner'];
  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_BY_USER_ID,
    queryId: String(userId),
    state: state,
    payload: {
      userId: userId,
    },
    onSuccess(partner) {
      state.set(currentPartnerStatePath, partner);
      state.set(['partners', 'bySlug', partner.slug], partner);
    },
  });
}
